import * as React from "react";
import { Stats, calculateUniformBins, calculateBinsHints } from '../model/index.js';
import { BinHintsPopup } from './BinHintsPopup.js';
export function BinDefinitionUniform({ data, setBins, decimals }) {
    const stats = React.useMemo(() => new Stats(data.map(x => x.value)), [data]);
    const binsHints = React.useMemo(() => calculateBinsHints(stats), [stats]);
    const [binParams, setBinParams] = React.useState({ h: getH(), pivotCentre: getPivotCentre() });
    const bins = React.useMemo(() => refreshBins(), [stats, binParams]);
    const h = React.useRef(null);
    const pivotCentre = React.useRef(null);
    function onSubmit(e) {
        e.preventDefault();
        setBinParams({
            h: getH(),
            pivotCentre: getPivotCentre(),
        });
    }
    function getH() {
        var _a;
        try {
            return Number((_a = h.current) === null || _a === void 0 ? void 0 : _a.value);
        }
        catch (error) {
            return Number(binsHints[0].h.toPrecision(3));
        }
    }
    function getPivotCentre() {
        var _a;
        try {
            return Number((_a = pivotCentre.current) === null || _a === void 0 ? void 0 : _a.value);
        }
        catch (error) {
            return Number(stats.average.toFixed(decimals));
        }
    }
    function refreshBins() {
        const bins = calculateUniformBins({
            orderedSample: stats.orderedSample,
            h: binParams.h,
            pivotCentre: binParams.pivotCentre,
        });
        return bins;
    }
    React.useEffect(() => setBins(bins), [bins]);
    return (React.createElement("div", { className: 'pig' },
        React.createElement("form", { id: "formBins", onSubmit: onSubmit },
            React.createElement("div", null,
                React.createElement("div", null,
                    React.createElement("label", { htmlFor: "binSize" }, "D\u00E9lka t\u0159\u00EDdy"),
                    React.createElement("input", { id: "binSize", defaultValue: binsHints[0].h.toPrecision(3), ref: h, onBlur: onSubmit })),
                React.createElement("div", null,
                    React.createElement("label", { htmlFor: "binCentre" }, "St\u0159ed t\u0159\u00EDdy"),
                    React.createElement("input", { id: "binCentre", defaultValue: stats.average.toFixed(decimals), ref: pivotCentre, onBlur: onSubmit })),
                React.createElement("div", null,
                    React.createElement("label", { htmlFor: "numBins" }, "Po\u010Det t\u0159\u00EDd"),
                    React.createElement("p", null, bins.length)),
                React.createElement("button", { style: { display: "none" } }))),
        React.createElement(BinHintsPopup, { binsHints: binsHints, decimals: decimals })));
}
//# sourceMappingURL=BinDefinitionUniform.js.map